import { Controller, useForm } from "react-hook-form";
import Field from "src/components/field";
import PageIntro from "src/components/PageIntro/PageIntro";
import { Switch } from "src/components/ui/switch";
import { SelectedContract } from "../types/SelectedContract";
import { OfferForm } from "../types/OfferObject";
import { Provider } from "src/components/ui/provider";
import {
  Accordion,
  Box,
  BoxProps,
  Button,
  ButtonGroup,
  Checkbox,
  Input,
  Span,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useEffect, useMemo,useState } from "react";
import { useGiveOfferMutation } from "src/lib/endpoints/hire/hire.api";
import useAlert from "src/hooks/use-alert";
import { useTypedSelector } from "src/lib/store/store";
import { selectUserState } from "src/lib/features/auth/authSlice";
import { useParams, useNavigate } from "react-router-dom";

type InputFields = {
  name: string;
  forCompany?: boolean;
  understand: boolean;
};

export default function ProjectSignaterySetup({
  contracts,
  offer,
  onBack,
}: {
  contracts: SelectedContract[];
  offer?: OfferForm;
  onBack: () => void;
}) {

  const { control, watch, register, handleSubmit } = useForm<InputFields>();
  const [isSubmitting, setIsSubmitting] = useState(false)

    const {
      state: alertState,
      open: openAlert,
      close: closeAlert,
      Alert,
    } = useAlert();
        const { user } = useTypedSelector(selectUserState);
const { jobId, userId } = useParams()
const navigate = useNavigate();

    // const onSubmit = () => {}


    // console.log('User ID:', userId)
    // console.log('Job ID:', jobId)

      const {isLoading, giveOffer} = useGiveOfferMutation({
     userId: userId ?? "",
  jobId: jobId ?? ""
  })

const onSubmit = async (data: InputFields) => {
 

  if (!data.understand) {
    openAlert({
      title: "You must agree to the terms before proceeding.",
      variant: "error",
      active: true,
    });
    return;
  }

  setIsSubmitting(true);

  const payload = {
    work_type: offer?.work_type ?? "fixedcost",
    payment_type: offer?.payment_type ?? "milestone-based",
    agreed_duration: offer?.agreed_duration ?? "30",
    agreed_hourly_rate: null,
    agreed_total_cost: offer?.agreed_total_cost ?? "0",
    retainer_agreed_interval: offer?.retainer_agreed_interval ?? null,
    retainer_agreed_interval_payment: offer?.retainer_agreed_interval_payment ?? null,
    status: "pending",
    startDate: offer?.startDate ?? new Date().toISOString().split("T")[0],
    milestones: JSON.stringify(offer?.milestones ?? []),
    description: offer?.description ? `${offer.description} — Signed by ${data.name}` : `Signed by ${data.name}`,
  };

  //  console.log('Submitting offer...', payload)

  giveOffer(payload, {
    onSuccess: (res) => {
      setIsSubmitting(false);

      openAlert({
        title: res?.message ?? "Offer processed",
        variant: res?.status ? "success" : "error",
        active: true,
      });

      if (res?.status) {
        // allow user to see success first
        setTimeout(() => {
          closeAlert?.();
          navigate("/project");
        }, 1200);
      }
    },

    onError: (error) => {
      setIsSubmitting(false);

      openAlert({
        title:
          error?.response?.data?.message ??
          error?.message ??
          "Something went wrong",
        variant: "error",
        active: true,
      });
    },
  });
};


  const name = watch().name;


  console.log("s: ", contracts);

  // useEffect(() => {
  //   for (const contract of contracts) {
  //     console.log("Contract: ", contract);
  //   }
  // }, contracts);

  return (
    <div className="@container ">
      <Alert />
      <div className="flex flex-col @4xl:flex-row gap-10">
        <div className="bg-gray-70 w-full @4xl:flex-1 ">
          <ContractsList contracts={contracts} />
        </div>

        <div className="@4xl:max-w-sm w-full">
          <Box p={4} spaceY={10} rounded={"md"} bg="bg.subtle">
            <PageIntro
              title="Review and Sign"
              description="Make sure your read and understand the terms in the contract. Type your name to sign."
            />

            <VStack
              as="form"
              onSubmit={handleSubmit(onSubmit)}
              align="stretch"
              gap={5}
            >
              {/* <Controller
            name="forCompany"
            control={control}
            render={({ field: { value, onChange } }) => {
              return (
                <Field>
                  <div className="flex gap-4 items-center">
                    <Switch
                      id="forCompany"
                      checked={value == true}
                      onCheckedChange={(checked) => onChange(checked)}
                    />
                    <label htmlFor="forCompany">I represent a company</label>
                  </div>
                </Field>
              );
            }}
          /> */}
              <Field>
                <Input
                  type="text"
                  placeholder="Full legal name"
                  borderWidth={"thin"}
                  px={2}
                  {...register("name", { required: "Enter your name" })}
                />
              </Field>

              <Controller
                name="understand"
                control={control}
                render={({ field: { value, onChange } }) => {
                  return (
                    <Field>
                      <Checkbox.Root
                        checked={value}
                        onCheckedChange={({ checked }) =>
                          onChange(checked == true)
                        }
                        alignItems={"flex-start"}
                      >
                        <Checkbox.HiddenInput />
                        <Checkbox.Control
                          _checked={{ bg: "secondary" }}
                          borderWidth={"thin"}
                          rounded={"sm"}
                        />
                        <Checkbox.Label fontWeight={"normal"} color="fg.muted">
                          I {name != "" && `${name},`} have read and understand
                          and here by agree to the terms & condition set forth
                          in this contract and agree to be legally bind by these
                          terms and conditions by checking this box.
                        </Checkbox.Label>
                      </Checkbox.Root>
                    </Field>
                  );
                }}
              />

              <ButtonGroup w="full" justifyContent={"space-between"} mt={10}>

                <Button onClick={onBack}>Back</Button>

            <Button
  type="submit"
  bg="primary"
  color="white"
disabled={isSubmitting}
className="px-3 py-1"
>
  Give Offer
</Button>


           

              </ButtonGroup>
            </VStack>
          </Box>
        </div>
      </div>
    </div>
  );
}

function ContractsList({ contracts }: { contracts: SelectedContract[] }) {
  const openDefault = contracts.length === 1 ? [contracts[0].type] : undefined;
  // console.log('Open default:', openDefault)

  return (
    <Accordion.Root
      multiple={openDefault == undefined}
      spaceY={4}
      defaultValue={openDefault}
    >
      {contracts.map((item, index) => (
        <Accordion.Item key={index} value={item.type}>
          <Accordion.ItemTrigger bg="bg.subtle" p={4} rounded={"md"}>
            <Span flex="1">{item.type}</Span>
            <Accordion.ItemIndicator />
          </Accordion.ItemTrigger>
          <Accordion.ItemContent>
            <Accordion.ItemBody>
              <PDFViewer rounded={"md"} data={item.file} />
            </Accordion.ItemBody>
          </Accordion.ItemContent>
        </Accordion.Item>
      ))}
    </Accordion.Root>
  );
}

function PDFViewer({ data, ...rest }: { data: string | File } & BoxProps) {
  return useMemo(() => {
    return (
      <Box asChild minH={"vh"} h="full" w={"full"} {...rest}>
        <embed
          src={typeof data === "string" ? data : URL.createObjectURL(data)}
          type="application/pdf"
        />
      </Box>
    );
  }, [data]);
}
